import { Box, Container, Divider, Grid } from "@mui/material";
import Skeleton from "../../../common/skeleton/skeleton";

function FlightSkeleton() {
    return (
        <Container maxWidth="xl">
            <Grid container item xs={12} rowGap={2} justifyContent="space-between" alignItems="flex-start">
                <Grid className="base-sort" container item xs={2} rowGap={1} display={{ xs: "none", md: "flex" }}>
                    <Skeleton variant="rounded" animation="wave" width="100%" height={30} />
                    <Skeleton variant="rounded" animation="wave" width="100%" height={200} />
                </Grid>

                <Grid container item xs={12} columnGap={2} display={{ xs: "flex", md: "none" }} alignItems="center" mt={2}>
                    <Skeleton variant="text" animation="wave" width={50} height={20} />
                    <Divider flexItem orientation="vertical" />
                    <Skeleton variant="text" animation="wave" width={50} height={20} />
                </Grid>

                <Grid container item md={9.8} rowGap={2}>
                    <Grid className="base-sort" container item xs={12} md="auto" columnGap={2} display={{ xs: "none", md: "flex" }}>
                        {[...Array(4)].map((_, index) => (
                            <Grid key={index} container item xs="auto">
                                <Skeleton variant="text" animation="wave" width={100} height={20} />
                            </Grid>
                        ))}
                    </Grid>

                    {[...Array(10)].map((_, index) => (
                        <Grid
                            className="flight-list__skeleton"
                            key={index}
                            container
                            item
                            xs={12}
                            rowGap={1}
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid container item xs={12} md={9} rowGap={1}>
                                <Grid container item xs={12} columnGap={1}>
                                    <Skeleton variant="text" animation="wave" width={80} height={40} />
                                    <Skeleton variant="text" animation="wave" width={80} height={40} />
                                    <Skeleton variant="text" animation="wave" width={80} height={40} />
                                </Grid>

                                <Grid container item xs={12} alignItems="center">
                                    <Grid container item xs={3.5} md={5} columnGap={2} alignItems="center">
                                        <Skeleton variant="circular" animation="wave" width={70} height={70} />
                                        <Box>
                                            <Skeleton variant="text" animation="wave" width={200} height={20} />
                                            <Skeleton variant="text" animation="wave" width={150} height={20} />
                                        </Box>
                                    </Grid>

                                    <Grid container item xs={8.5} md={7} justifyContent="center">
                                        <Skeleton variant="text" animation="wave" width={300} height={20} />
                                        <Skeleton variant="text" animation="wave" width={300} height={20} />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Divider orientation="vertical" flexItem sx={{ display: { xs: "none", md: "flex" } }} />

                            <Grid
                                container
                                item
                                xs={12}
                                md={2.5}
                                display={{ xs: "none", md: "flex" }}
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Skeleton variant="text" animation="wave" width="100%" height={20} />
                                <Skeleton variant="text" animation="wave" width="100%" height={50} />
                                <Skeleton variant="text" animation="wave" width={120} height={20} />
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Container>
    );
}

export default FlightSkeleton;
